import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async toggle(event) {
    // クリック対象は文字 span のため、URL ・ハイライト状態を持つ親 row を探す
    const row = event.currentTarget.closest("[data-toggle-url]") || event.currentTarget
    const url = row.dataset.toggleUrl
    if (!url) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const response = await fetch(url, {
      method: "PATCH",
      headers: { "X-CSRF-Token": csrfToken }
    })

    if (response.ok) {
      const isHighlighted = row.dataset.highlighted === "true"
      this.applyHighlight(row, !isHighlighted)
      row.dataset.highlighted = isHighlighted ? "false" : "true"
    }
  }

  applyHighlight(row, highlight) {
    row.querySelectorAll("span").forEach((span) => {
      if (highlight) {
        const textClasses = [...span.classList].filter((cls) => cls.startsWith("text-"))
        const fontClasses = [...span.classList].filter((cls) => cls.startsWith("font-"))
        span.dataset.originalClass = [...textClasses, ...fontClasses].join(" ")
        textClasses.forEach((cls) => span.classList.remove(cls))
        fontClasses.forEach((cls) => span.classList.remove(cls))
        span.classList.add("text-red-600", "font-bold")
      } else {
        span.classList.remove("text-red-600", "font-bold")
        const original = span.dataset.originalClass
        if (original) {
          original.split(" ").forEach((cls) => span.classList.add(cls))
        }
      }
    })
  }
}
